import CreateUserModal from './CreateUserController';

export default CreateUserModal;
